var _path;
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMoonOutlined(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 18 18",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m4.354 13.383.112.488-.112-.488Zm-.234.9-.248.434.248-.434ZM8.313 3.198l.101-.49-.101.49Zm-.42.83-.406.29.406-.29Zm4.355 6.994a5.5 5.5 0 0 1-7.09 3.198l-.354.935a6.5 6.5 0 0 0 8.38-3.78l-.936-.354ZM9.05 3.931a5.5 5.5 0 0 1 3.2 7.09l.934.353a6.5 6.5 0 0 0-3.78-8.379l-.354.935Zm-.838-.244c.281.058.561.139.838.243l.354-.935a6.544 6.544 0 0 0-.989-.288l-.203.98Zm-.724.63a5.494 5.494 0 0 1 .68 5.16l.935.354a6.494 6.494 0 0 0-.803-6.097l-.812.584Zm.68 5.16a5.494 5.494 0 0 1-3.924 3.418l.223.975a6.495 6.495 0 0 0 4.636-4.04l-.935-.353ZM5.158 14.22a5.55 5.55 0 0 1-.79-.372l-.496.869c.295.168.606.315.932.438l.354-.935Zm-.915-1.324a1.085 1.085 0 0 0-.801.753.916.916 0 0 0 .43 1.068l.496-.869c-.002 0 .004.002.011.011.008.01.015.02.02.033.008.024.003.036.005.031a.088.088 0 0 1 .062-.053l-.223-.974ZM8.414 2.708a.916.916 0 0 0-1.03.516c-.157.329-.142.755.103 1.095l.812-.584a.088.088 0 0 1-.012-.08c.002-.005-.002.007-.025.02a.107.107 0 0 1-.035.012c-.012.002-.018 0-.016 0l.203-.979Z",
    fill: "#8E8E8E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMoonOutlined);
export default __webpack_public_path__ + "static/media/moon-outlined.009ffb1c.svg";
export { ForwardRef as ReactComponent };